import * as React from 'react';
import { EditUserDialogModel, TeamItemModel } from './model/TeamModel';
import { TeamController } from './controller/TeamController';
import { Dialog } from 'components/dialog';
import { TextField } from 'components/input/TextField';
import { SimpleSelect, SelectItem } from 'components/input/SimpleSelect';
import { EUserRole } from 'utils/meta';
import { Button } from '@material-ui/core';

export class EditUserDialog extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);

        var m = props.model;
        this.state = { name: m.name, role: m.role, teamId: m.teamId };

        this.handleCancelButtonClicked = this.handleCancelButtonClicked.bind(this);
        this.handleSaveButtonClicked = this.handleSaveButtonClicked.bind(this);
    }

    private handleCancelButtonClicked() {
        this.props.controller.onEditUserCancelClicked();
    }

    private handleSaveButtonClicked() {
        var m = this.props.model;
        m.name = this.state.name;
        m.role = this.state.role;
        m.teamId = this.state.teamId;
        this.props.controller.onEditUserSaveClicked(m);
    }

    public render() {
        return (
            <Dialog title="Edit user" desc="Use this form to change user properties!">
                <TextField label="Name" value={this.state.name} desc="The name of the user." error={this.props.model.nameError} onChange={(v) => { this.setState({ name: v }) }} />
                <SimpleSelect label="Role" defaultValue={this.state.role} error={this.props.model.roleError} infoText="The role of the user." onChange={(v) => { this.setState({ role: v }) }}>
                    {EUserRole.values().map((r) => (<SelectItem key={"role-" + r.name} value={r.name} title={r.title} />))}
                </SimpleSelect>
                <SimpleSelect label="Team" defaultValue={this.state.teamId} error={this.props.model.teamError} infoText="The team of the user." onChange={(v) => { this.setState({ teamId: v }) }}>
                    {[<SelectItem key="team-none" value="" title="No team" />].concat(this.props.teams.map((t) => (<SelectItem key={"team-" + t.id} value={"" + t.id} title={t.name} />)))}
                </SimpleSelect>
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%' }}>
                    <Button color="secondary" onClick={this.handleCancelButtonClicked}>Cancel</Button>
                    <Button style={{ marginLeft: '8px' }} color="primary" variant="contained" onClick={this.handleSaveButtonClicked}>Save</Button>
                </div>
            </Dialog>
        );
    }

}

export interface Props {

    model: EditUserDialogModel;
    teams: TeamItemModel[];
    controller: TeamController;

}

interface State {

    name: string;
    role: string;
    teamId: string;

}
